import React from 'react';
import { useGetCards } from 'hooks/CardHooks';
import { useGetCarts } from 'hooks/CartHooks';
import { useGetCouponUsers } from 'hooks/CouponUserHooks';
import { useGetDeliveryAddresses } from 'hooks/DeliveryAddressHooks';
import { useGetInquiries } from 'hooks/InquiryHooks';
import { useGetReviews } from 'hooks/ReviewHooks';
import { useGetWishlists } from 'hooks/WishlistHooks';
import { useUserDataAction } from 'store';

const UserDataProvider = ({ children, user = null }) => {
  /* ===== Variables ===== */
  // NOTE: 쿼리
  const query = {
    user_id: user?.user_id,
  };
  // NOTE: 쿼리 옵션
  const options = {
    select: (res) => {
      const { status, data } = res;

      if (status !== 200) return [];
      else return data;
    },
    enabled: !!user,
    initialData: [],
  };

  /* ===== Store ===== */
  const action = useUserDataAction();

  /* ===== Data ===== */
  /**
   * SECTION 장바구니 데이터
   * --
   */
  const { data: CartList } = useGetCarts(query, options);

  React.useEffect(() => {
    if (!CartList.length) return;

    action.setData('cartList', CartList);
    // eslint-disable-next-line
  }, [CartList]);

  /**
   * SECTION 위시리스트 데이터
   * --
   */
  const { data: Wishlist } = useGetWishlists(query, options);

  React.useEffect(() => {
    if (!Wishlist.length) return;

    action.setData('wishlist', Wishlist);
    // eslint-disable-next-line
  }, [Wishlist]);

  /**
   * SECTION 쿠폰 데이터
   * --
   */
  const { data: CouponList } = useGetCouponUsers(
    { ...query, join_tables: '["map_product_policy"]' },
    options
  );

  React.useEffect(() => {
    if (!CouponList.length) return;

    // 쇼핑몰 상품 할인쿠폰 필터
    const filteredCouponList = CouponList.filter(
      (coupon) => coupon.policy_coupon.coupon_type === 'PRODUCT'
    );

    // 사용중인 정책 필터
    const newCouponList = filteredCouponList.map((coupon) => ({
      ...coupon,
      map_product_policy:
        coupon.map_product_policy && coupon.map_product_policy.length
          ? coupon.map_product_policy.filter(
              (policy) => policy.is_enable === 'Y'
            )
          : [],
    }));

    action.setData('couponList', newCouponList);
    // eslint-disable-next-line
  }, [CouponList]);

  /**
   * SECTION 배송지 데이터
   * --
   */
  const { data: DeliveryAddress } = useGetDeliveryAddresses(query, options);

  React.useEffect(() => {
    if (!DeliveryAddress.length) return;

    action.setData('deliveryAddress', DeliveryAddress);
    // eslint-disable-next-line
  }, [DeliveryAddress]);

  /**
   * SECTION 리뷰 데이터
   * --
   */
  const { data: Reviews } = useGetReviews(
    { ...query, join_tables: '["review_file"]' },
    options
  );

  React.useEffect(() => {
    if (!Reviews.length) return;

    action.setData('reviews', Reviews);
    // eslint-disable-next-line
  }, [Reviews]);

  /**
   * SECTION 등록 카드 데이터
   * --
   */
  const { data: Cards } = useGetCards({ ...query, is_enable: 'Y' }, options);

  React.useEffect(() => {
    if (!Cards.length) return;

    action.setData('cardList', Cards);
    // eslint-disable-next-line
  }, [Cards]);

  /**
   * SECTION 문의 데이터
   * --
   */
  const { data: Inquiries } = useGetInquiries(
    { ...query, join_tables: '["inquiry_file"]' },
    options
  );

  React.useEffect(() => {
    if (!Inquiries.length) return;

    action.setData('inquiryList', Inquiries);
    // eslint-disable-next-line
  }, [Inquiries]);

  /* ===== Render ===== */
  return <React.Fragment>{children}</React.Fragment>;
};
export default UserDataProvider;
